<template>
    <div class="demand_box">
        <div class="demand_head">
            <div class="demand_head_conter">
                <span class="demand_head_conter_back" style="margin-right: 30px;cursor: pointer;" @click="toCoursePage"><i></i>返回</span>
                <span>
                  {{courseInfo.course.course_name && lessonInfo.lesson_name ? `${courseInfo.course.course_name} - ${lessonInfo.lesson_name}`: ''}}
                </span>
            </div>
        </div>
        <div class="demand_main">
            <div class="demand_main_left">
                <video ref='player' id="player" style="width:100%; height:100%;" preload="auto" playsinline webkit-playsinline></video>
            </div>
            <drawer v-if='courseInfo.lesson.length>0' :parentData='courseInfo.lesson' :lessonid='lessonInfo.lesson_id' @selectLesson='changeLesson'></drawer>
        </div>
        <el-dialog title="提示" class="live_tit_box" :visible="showToOrderDialog" width="20%" :show-close="false" :close-on-click-modal="false">
          <span>该课程未开通，请先购买课程</span>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="toOrderPage">确 定</el-button>
          </span>
        </el-dialog>
    </div>
</template>


<script>
    import store from '../store'
    import Drawer from '@/components/drawer'
    import request from '@/common/request.js'
    import courseApi from "@/apis/course/course.js"
    import memberApi from "@/apis/member/member.js"
    import {createThrottle} from '@/common/utils.js'

  /**
   * 播放统计周期维护：
   * 1. 视频开始播放事件：统计周期开始 -> videoCircleStart()，初始化统计周期数据
   * 2. 视频时间变化事件：统计周期进行 -> videoCircleProcess()，未暂停时更新学习记录、视频区间，最后观看事件只要视频事件修改就一定更新
   * 3. 视频暂停播放事件：统计周期结束 -> videoCircleOver()，设置当前学习记录以及当前视频区间为空，这一步是快速断开属性连接，防止这两个数据被其他事件修改
   * 4. 统计上传时机上传：获取数据快照、重置统计周期数据、上报统计数据
   *
   * 统计上传方法(videoCircleRelateReport)
   * 1. 获取学习记录、视频观看记录、视频最后观看事件点、课程ID、课时ID、课时类型的快照数据，这一步时防止后续处理的时候，其他事件会修改这些数值，从而导致数据异常
   * 2. 统计周期数据重置：暂停时学习记录、视频区间记录、视频最后时间重置；不是暂停时则设置为当前时间相关值
   * 3. 更新学习记录+更新的视频时长、最后时长为空，不上报
   *
   * 统计上传时机
   * 1. 定时上传：页面初始化时创建定时器
   *    initVideoCircleCall()
   * 2. 视频暂停时上传：触发视频暂停事件
   *    this.videoCircleRelateReport("视频暂停")，需要防止误触发，可是切换以及离开页面
   * 3. 课时切换：选择其他课时、通过浏览器自带前进后退由播放页面进行播放页面
   *    this.videoCircleRelateReport("课时切换")
   *    this.videoPlayer.player.pause()
   * 4. 离开页面：浏览器自带前进后退、播放页面右上角按钮
   *    this.videoCircleRelateReport("离开页面")
        this.videoPlayer.player.pause()
   * 5. 关闭页面：刷新页面、关闭标签(可能不会触发,如果用户没有操作过页面的话有概率失败)；关闭浏览器(可能不会触发,如果用户没有操作过页面的话)
   *    this.videoCircleRelateReport("关闭页面")
   * 6. 视频暂停时切换进度：视频进度变化事件
   *   this.videoCircleRelateReport("视频暂停切换进度") 判断当前视频暂停，为防止跟暂停提交冲突(提交的时候会重置统计)，以及防抖，设计3秒防抖
   */
    const lessonTypeMap = {}
    const LessonTypeLive = "live"
    const LessonTypeVideo = "video"
    const LessonTypePlayback = "playback"
    const LessonTypeLiveValue = 1
    const LessonTypeVideoValue = 2
    const LessonTypePlaybackValue = 3
    lessonTypeMap[LessonTypeLive] = LessonTypeLiveValue
    lessonTypeMap[LessonTypeVideo] = LessonTypeVideoValue
    lessonTypeMap[LessonTypePlayback] = LessonTypePlaybackValue

    // 暂停切换进度防抖
    const videoPauseTimeupdateThrottle = createThrottle()

    export default {
        components:{
            Drawer
        },
        data() {
            return {
              showToOrderDialog: false,
              isLeavePage: false, // 是否已经离开页面，离开页面时不进行暂停处理
              params: {
                lesson_id: "", // 路由传入
              },
              processInfo: {
                lastDuration: 0, // 上一次看到的位置
              },
              lessonInfo: {  // 课时信息
                lesson_id: '',
                lesson_course_id: '',
                lesson_name: "",
                lesson_media_uri: '', // 腾讯云视频ID
              },
              courseInfo: {  // 课程信息
                course: {
                  course_name: ""
                },
                lesson: []
              },
              videoPlayer: {  // 视频播放器
                appid: '1258058949', // 视频播放器ID
                player: null,  // 视频播放器实例
              },
              videoStatic: { // 视频观看统计
                reportIndex: null, // 上传周期序号
                timestampRanges: [], // 播放时间戳区间数组
                timestampRange: [], // 播放时间戳区间
                durationRanges: [], // 播放时间区间数组
                durationRange: [], // 播放时间区间
                lastDuration: 0, // 最后播放时间节点
              }
            };
        },
        methods: {
          // 页面参数初始化
          initParams() {
            this.params.lesson_id = Number(this.$route.query.lesson_id)
            this.lessonInfo = {}
            this.videoStatic.timestampRange = []
            this.videoStatic.timestampRanges = []
            this.videoStatic.durationRange = []
            this.videoStatic.durationRanges = []
            this.videoStatic.lastDuration = 0
          },
          // 页面初始化
          async initPage(options = {})  {
            // skip*的参数主要用于跳过加载,应对同路由跳转
            try {
              await this.initLesson() // 页面初始化课时信息
              await this.initLessonVideoProcess() // 页面初始化课时视频播放进度
              !options.skipInitCourse && await this.initCourse() // 页面初始化课程信息
              this.initReportVideoStaticTime() // 上报观看次数
              this.initVideo() // 页面初始化视频
              !options.skipInitVideoCircleCall && this.initVideoCircleCall() // 周期调用
            } catch(e) {
              console.log(e)
            }
          },
          // 页面初始化课时信息
          async initLesson() {
            // 加载课时信息
            const lessonResp = await courseApi.getLesson(this.params.lesson_id)
            if(lessonResp.code == 10002) {
              this.showToOrderDialog=true;
              throw Error("加载课时信息失败："+lessonResp.msg)
            }
            if(lessonResp.code != 1) {
              throw Error("加载课时信息失败："+lessonResp.msg)
            }
            // 设置课时信息
            this.lessonInfo = lessonResp.data
          },
          // 页面初始化课时视频播放进度
          async initLessonVideoProcess() {
            // 获取播放进度
            const lessonType = lessonTypeMap[this.lessonInfo.lesson_type]
            const lessonProcessResp = await courseApi.getLessonLiveProccess(this.lessonInfo.lesson_course_id, this.lessonInfo.lesson_id, lessonType)
            if(lessonProcessResp.code == 1) {
              this.processInfo.lastDuration = lessonProcessResp.data && lessonProcessResp.data.last_video_time ? lessonProcessResp.data.last_video_time : 0
            }
          },
          // 页面初始化课程信息
          async initCourse() {
            // 获取课程目录信息
            const courseResp = await courseApi.getCourseLesson(this.lessonInfo.lesson_course_id)
            if(courseResp.code != 1) {
              throw Error("加载课程信息失败："+courseResp.msg)
            }
            // 设置课程信息
            this.courseInfo = courseResp.data
          },
          // 页面初始化视频
          initVideo() {
            if(!this.videoPlayer.player) {
              this.videoPlayer.player = TCPlayer(this.$refs.player, {
                  fileID: this.lessonInfo.lesson_media_uri, // 请传入需要播放的视频 filID 必须
                  appID: this.videoPlayer.appid, // 请传入点播账号的 appID 必须
                  // autoplay:true,
                  plugins: {
                      ProgressMarker: true
                  }
              })

              this.videoPlayer.player.on('playing', () => {
                this.videoCircleStart()
              })

              this.videoPlayer.player.on('pause', () => {
                // 离开页面的时候播放器会暂停, 会触发暂停事件， 但是离开页面的统计提交，不由该事件处理，所以需要判断返回
                if(this.isLeavePage) {
                  return
                }
                // 切换课时的时候，会暂停视频，可能会触发暂停事件，导致不正确统计的提交，所以这里需要判断返回
                if(this.lessonInfo.lesson_id != this.params.lesson_id) {
                  return
                }
                this.videoCircleOver()
                this.videoCircleRelateReport("视频暂停") // 上传视频周期统计信息
              })

              this.videoPlayer.player.on('timeupdate', () => {
                const isPaused = this.videoPlayer.player.el_.getElementsByTagName("video")[0].paused
                this.videoCircleProcess(isPaused)
                // 这里使用防抖，防止跟暂停提交的逻辑冲突
                isPaused && videoPauseTimeupdateThrottle(() => {
                  if(this.videoPlayer.player.el_.getElementsByTagName("video")[0].paused) {
                    this.videoCircleRelateReport("视频暂停切换进度")
                  }
                }, 3000, false)
              })

              this.videoPlayer.player.on('loadedmetadata', () => {
                console.groupCollapsed(`定位上次观看位置-${this.lessonInfo.lesson_id}-${this.processInfo.lastDuration}`)
                console.groupEnd()
                this.videoPlayer.player.currentTime(this.processInfo.lastDuration)
                this.videoPlayer.player.play()
              })
            } else {
              this.videoPlayer.player.loadVideoByID({
                fileID: this.lessonInfo.lesson_media_uri,
                appID: this.videoPlayer.appid
              })
            }
          },
          // 视频周期进行中
          videoCircleProcess(isPaused) {
            if(!isPaused) {
              // 增加时间戳区间右节点数值
              this.videoStatic.timestampRange[1] = Math.floor(Date.now()/1000)
              // 增加时间区间右节点数值
              this.videoStatic.durationRange[1] = Math.max(this.videoPlayer.player.currentTime(), this.videoStatic.durationRange[0], this.videoStatic.durationRange[1])
            }
            this.videoStatic.lastDuration = this.videoPlayer.player.currentTime()
          },
          // 视频周期结束
          videoCircleOver() {
            // console.log("========== [视频周期 - 结束] ==========")
            // 重置时间戳区间
            this.videoStatic.timestampRange = []
            // 重置时间区间
            this.videoStatic.durationRange = []
          },
          // 视频周期开始
          videoCircleStart() {
            // 初始化时间戳区间
            this.videoStatic.timestampRange = [Math.floor(Date.now()/1000), Math.floor(Date.now()/1000)]
            this.videoStatic.timestampRanges.push(this.videoStatic.timestampRange)
            // 初始化时间区间
            this.videoStatic.durationRange = [this.videoPlayer.player.currentTime(), this.videoPlayer.player.currentTime()]
            this.videoStatic.durationRanges.push(this.videoStatic.durationRange)
          },
          // 页面周期调用
          initVideoCircleCall() {
            if(this.videoStatic.reportIndex === null) {
              this.videoStatic.reportIndex = setInterval(() => {
                this.videoCircleRelateReport("定时")
              }, 40*1000)  // 周期上传视频统计
            }
          },
          // 视频相关统计上传
          async videoCircleRelateReport(tipsTitle = "") {
            const courseId = this.lessonInfo.lesson_course_id
            const lessonId = this.lessonInfo.lesson_id
            const lessonType = lessonTypeMap[this.lessonInfo.lesson_type]
            const isPaused = this.videoPlayer.player.el_.getElementsByTagName("video")[0].paused
            const lastDuration = Math.ceil(this.videoStatic.lastDuration)
            const timestampRanges = JSON.parse(JSON.stringify(this.videoStatic.timestampRanges)) // 时间戳区间
            const durationRanges = JSON.parse(JSON.stringify(this.videoStatic.durationRanges)) // 时间区间

            // 重置时间戳区间 以及 重置时间区间
            if(isPaused) {
              this.videoStatic.timestampRange = []
              this.videoStatic.timestampRanges = []
              this.videoStatic.durationRange = []
              this.videoStatic.durationRanges = []
              this.videoStatic.lastDuration = 0
            } else {
              const currentTime = this.videoPlayer.player.currentTime()
              this.videoStatic.timestampRange = [Math.floor(Date.now()/1000), Math.floor(Date.now()/1000)]
              this.videoStatic.timestampRanges = [this.videoStatic.timestampRange]
              this.videoStatic.durationRange = [currentTime, currentTime]
              this.videoStatic.durationRanges = [this.videoStatic.durationRange]
              this.videoStatic.lastDuration = currentTime
            }

            // 计算观看时间
            let seeVideoTime = timestampRanges.reduce((sum, value) => sum + Math.abs(value[1] - value[0]), 0)
            // 时间区间转换成整数
            for(let i in durationRanges) {
              for(let j in durationRanges[i]) {
                durationRanges[i][j] = Math.ceil(durationRanges[i][j])
              }
            }

            // 提前返回 - 这里之不是不想打印，不处理也是可以的
            if(seeVideoTime == 0 && lastDuration == 0) {
              if(timestampRanges.length==0) {
                return
              }
            }

            console.groupCollapsed(`${tipsTitle}时上报服务器-${this.lessonInfo.lesson_id}`)

            // 上传统计信息
            this.reportVideoStatic(courseId, lessonId, lessonType, seeVideoTime, lastDuration, durationRanges, 2)

            // 上报学习信息
            this.reportStudyTime(1, timestampRanges)

            console.groupEnd()
          },
          // [观看统计] 上报服务器
          reportVideoStatic(courseId, lessonId, lessonType, seeVideoTime, lastTime, arrayData, terminal) {
            if(seeVideoTime == 0 && lastTime == 0) {
              console.table({title: `观看统计无变化,不上报服务器`})
              return Promise.resolve({code: 1, msg: "no submit"})
            }
            console.table({title: `观看统计上报服务器`, courseId, lessonId, lessonType, seeVideoTime, lastTime, arrayData: JSON.stringify(arrayData), terminal})
            return courseApi.addLessonVideoLookTime(courseId, lessonId, lessonType, seeVideoTime, lastTime, arrayData, terminal)
          },
          // [学习记录] 上报服务器
          reportStudyTime(studyDurationType, studyTime) {
            if(studyTime.length==0) {
              console.table({title: `学习时间无变化,不上报服务器`})
              return Promise.resolve({code: 1, msg: "no submit"})
            }
            console.table({title: `学习记录上报服务器`, studyDurationType, studyTime:JSON.stringify(studyTime)})
            return memberApi.addLessonVideoLookTime(studyDurationType, studyTime)
          },
          // [观看次数统计]
          initReportVideoStaticTime() {
            courseApi.addLessonVideoTime(this.lessonInfo.lesson_course_id, this.lessonInfo.lesson_id, lessonTypeMap[this.lessonInfo.lesson_type])
          },
          // 点击切换课时
          changeLesson(lesson) {
            if(lesson.lesson_id != this.params.lesson_id) {
              this.$router.push({path: "/demand", query: { lesson_id: lesson.lesson_id}})
            }
          },
          // 去订单页面
          toOrderPage() {
            let courseId = this.lessonInfo.lesson_course_id || this.courseInfo.course.course_id || this.$route.query.course_id || 0
            this.$router.push({name:'submitOrder',params:{course_id: courseId}})
          },
          // 去课程页面
          toCoursePage() {
            let courseId = this.lessonInfo.lesson_course_id || this.courseInfo.course.course_id
            if(courseId) {
              this.$router.push({name:'courseDescription', params: {course_id: courseId}})
            } else {
              history.go(-1)
            }
          },
        },
        created() {
          this.initParams()
          this.initPage()
          window.onbeforeunload = (e) => {
            // 直接调用上传即可，无需暂停，因为用户可能拒绝关闭，这样子可以保持统计周期的重置
            this.videoCircleRelateReport("关闭页面")
            return e.returnValue = '关闭提示'
          }
        },
        beforeRouteUpdate(to, from, next) {
          // 上报统计数据
          this.videoCircleRelateReport("课时切换")
          this.videoPlayer.player.pause()
          next()
          // 初始化参数
          this.initParams()
          this.initPage({skipInitCourse: true, skipInitVideoCircleCall: true})
        },
        beforeRouteLeave(to, from, next) {
          // 设置离开页面标识
          this.isLeavePage = true
          // 上报统计数据
          this.videoCircleRelateReport("离开页面")
          this.videoPlayer.player && this.videoPlayer.player.pause()
          // 清空定时器
          this.videoStatic.reportIndex && clearInterval(this.videoStatic.reportIndex)
          // 清空页面退出
          window.onbeforeunload = null
          next()
        }
    }
</script>

<style scoped>
    .demand_box{
        width: 100%;
        height: 100%;
        background: #333333;
        overflow: hidden;
        padding-bottom: 90px;
        box-sizing: border-box;
    }
    .demand_head{
        width: 100%;
        background: #222;
        height: 60px;
    }
    .demand_head_conter{
        margin: 0 50px;
        line-height: 60px;
    }
    .demand_head_conter_back{
        color: #00C590 !important
    }
    .demand_head_conter span{
        display: inline-block;
        font-size: 18px;
        color: #fff;
    }
    .demand_head_conter i{
        display: inline-block;
        width: 8px;
        height: 15px;
        background: url('../assets/more.png') no-repeat 0 0;
        background-size: cover;
        margin-right: 10px;
    }
    .demand_main{
        margin: 0 50px;
        height: 100%;
        position: relative;
        box-sizing: border-box;
    }
    .demand_main_left{
        width: 100%;
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/page/Demand.vue